module.exports = __webpack_public_path__ + "img/case.28c9a8b2.png";